var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointEditing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.25 6.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0.75H0.75",
    stroke: "#B59292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.25 16.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0.75H0.75",
    stroke: "#B59292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.25 13.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C5.40685 6.75 6.75 5.40685 6.75 3.75C6.75 2.09315 5.40685 0.75 3.75 0.75C2.09315 0.75 0.75 2.09315 0.75 3.75C0.75 5.40685 2.09315 6.75 3.75 6.75Z",
    stroke: "#B59292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.25 3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75C5.40685 6.75 6.75 5.40685 6.75 3.75C6.75 2.09315 5.40685 0.75 3.75 0.75C2.09315 0.75 0.75 2.09315 0.75 3.75C0.75 5.40685 2.09315 6.75 3.75 6.75Z",
    stroke: "#B59292",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointEditing);
export default __webpack_public_path__ + "static/media/point-editing.4514d0a8b37b22cf8b82e69c31ae1308.svg";
export { ForwardRef as ReactComponent };